import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { Observable } from 'rxjs';
import { SidepanelService } from './side-panel.service';

@Component({
  selector: 'crm-sidepanel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss'],
  standalone: true,
  imports: [MatSidenavModule, MatIconModule, CommonModule, GalaxyEmptyStateModule, MatToolbarModule, MatButtonModule],
})
export class SidepanelComponent implements AfterContentInit {
  @ViewChild('content', { static: true, read: ViewContainerRef }) contentContainerRef?: ViewContainerRef;

  headerTitle$: Observable<string>;
  isOpen$: Observable<boolean>;

  constructor(private sidepanelService: SidepanelService) {
    this.isOpen$ = this.sidepanelService.isOpen$;
    this.headerTitle$ = this.sidepanelService.headerTitle$;
  }

  ngAfterContentInit(): void {
    this.sidepanelService.setViewContainer(this.contentContainerRef);
  }

  public closeSidepanel(): void {
    this.sidepanelService.closeSidepanel();
  }
}
